import React from 'react'

const Tenders = () => {
    return (
        <div>
            <h1>Tenders</h1>
        </div>
    )
}

export default Tenders